module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "title": "停车场 ",
      "type": "success",
      "closable": false
    }
  }, [_vm._v("\n    " + _vm._s(_vm.parkInfo.name) + "[" + _vm._s(_vm.parkInfo.code) + "]\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.entity,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属企业",
      "prop": "corpId1"
    }
  }, [_c('corp-select', {
    model: {
      value: (_vm.entity.corpId1),
      callback: function($$v) {
        _vm.$set(_vm.entity, "corpId1", $$v)
      },
      expression: "entity.corpId1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物业",
      "prop": "corpId2"
    }
  }, [_c('corp-select', {
    model: {
      value: (_vm.entity.corpId2),
      callback: function($$v) {
        _vm.$set(_vm.entity, "corpId2", $$v)
      },
      expression: "entity.corpId2"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215e28fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/parkInfo/BindCorp.vue
// module id = 317
// module chunks = 0